import React, { Component } from 'react';
import mapSurveyResponses from '../../../helpers/mapSurveyQuestions';

class Redirect extends Component {

    state = {
        submitting: false
    }

    saveAndContinue = async (questionId, value) => {

        await this.props.handleChange(questionId, value);

        const nextStep = this.props.nextStep

        if (!this.props.lastQuestion) {
            setTimeout(function () {
                nextStep(false)
            }, 150)
        }
    }

    render() {

        let { questionId, question, placeholder, disclaimer, disclaimerCheckbox, disclaimerChecked, callToAction, negCallToAction } = this.props.data;

        const isDisabled = this.state.submitting || (disclaimerCheckbox && !disclaimerChecked);

        return (
            <div>
                <h3>
                    <span dangerouslySetInnerHTML={{ __html: mapSurveyResponses(question, this.props.fullSurvey) }}></span>
                </h3>
                <div className="mt-3">
                    <a 
                        className={`btn btn-primary btn-lg ${isDisabled ? 'disabled' : ''}`} 
                        onClick={(e) => { 
                            if (isDisabled) {
                                e.preventDefault();
                                return false;
                            }
                            this.saveAndContinue(questionId, "Clicked");
                        }} 
                        href={isDisabled ? '#' : `${mapSurveyResponses(placeholder, this.props.fullSurvey)}`} 
                        target={isDisabled ? '' : '_blank'}
                        style={isDisabled ? { pointerEvents: 'none', opacity: 0.6 } : {}}
                    >
                        {callToAction !== '' ? callToAction : 'Go Here!'}
                    </a>
                </div>
                <div className="mt-3">
                    <button 
                        className="btn btn-lnk text-secondary" 
                        onClick={() => { this.saveAndContinue(questionId, "No Thanks") }}
                        disabled={isDisabled}
                        style={isDisabled ? { opacity: 0.6 } : {}}
                    >
                        <u>{negCallToAction !== '' ? negCallToAction : 'No Thanks!'}</u>
                    </button>
                </div>
                <div className="mt-5">
                    {disclaimerCheckbox &&
                        <div className="alert alert-secondary d-inline-block mx-auto">
                            <div className="form-check mr-2">
                                <input type="checkbox" className="form-check-input" id={"disclaimerCheckbox"+questionId} checked={disclaimerChecked} onChange={event => this.props.handleChange(questionId, event.target.checked, false, true, 'disclaimerChecked')} />
                                <label className="form-check-label" htmlFor={"disclaimerCheckbox"+questionId}>
                                    I agree
                                </label>
                            </div>
                        </div>
                    }
                    <p dangerouslySetInnerHTML={{ __html: mapSurveyResponses(disclaimer, this.props.fullSurvey) }} className="text-info text-small text-center"></p>
                </div>
            </div>
        );
    }
}

export default Redirect;